import hardware from './hardware.prod'
import newOrgs from './new-orgs.prod.json'

const commonPlanProperties = {
    group_key: 'pro',
    label: 'Travel Ball',
    description: 'Travel Ball',
    stripe_product_id: 'prod_PUBLkEXMKaP6AU',
    badge: '',
    free_hardware: true,
    free_hardware_categories: ['bat_attachment'],
    includes_coaching: false,
    hardware_options: hardware.filter((h) => {
        return (
            (h.category === 'bat_attachment' && h.price === 0) ||
            (h.category === 'short_bat' && h.price === 6930)
        )
    }),
    is_travel_ball: true,
}

const monthlyPlan = {
    ...commonPlanProperties,
    map_key: 'pro_monthly',
    billing_interval: 'monthly',
    price: 3900,
    price_monthly: 3900,
}

const yearlyPlan = {
    ...commonPlanProperties,
    map_key: 'pro_yearly',
    billing_interval: 'yearly',
    price: 35500,
    price_monthly: 2958,
}

const orgs = {
    'power-baseball': {
        name: 'Power Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OfCytIDrm6Z6HgYm5S1ugU2',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSIXIDrm6Z6HgYZEhQ4vZH',
            } as StripePlan,
        ],
    },
    'slammers': {
        name: 'Slammers',
        coupon: 'slammers1',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OgsSAIDrm6Z6HgYdS97BIdQ',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            // {
            //     ...yearlyPlan,
            //     stripe_price_id: 'price_1OrSIiIDrm6Z6HgYjWMWJOfY',
            // } as StripePlan,
        ],
    },
    'dulins-dodgers': {
        name: 'Dulins Dodgers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P5aUEIDrm6Z6HgYkAG4zeH2',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSIxIDrm6Z6HgYUt2zobsU',
            } as StripePlan,
        ],
        features: {
            headsetFinancing: {
                upfrontPayment: 6000,
                numberOfMonths: 12,
                monthlyPayment: 2000,
            },
        },
    },
    'iowa-sticks': {
        name: 'Iowa Sticks',
        coupon: 'iowasticks1',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OjOpvIDrm6Z6HgYvoswpX9A',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
        ],
    },
    'marucci-elite': {
        name: 'Marucci Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OmO3sIDrm6Z6HgYbzPlrVsy',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSJrIDrm6Z6HgYI0R9b1k2',
            } as StripePlan,
        ],
    },
    'hunter-pence': {
        name: 'Hunter Pence',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OlxmDIDrm6Z6HgYVAPsZjom',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSJcIDrm6Z6HgYABuPrKgv',
            } as StripePlan,
        ],
    },
    'east-coast-development': {
        name: 'East Coast Sox',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Olxm0IDrm6Z6HgYnT8FLgN7',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSJQIDrm6Z6HgYgW4ikRyV',
            } as StripePlan,
        ],
    },
    'p2p-millers': {
        name: 'P2P Millers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Oo7XaIDrm6Z6HgY27mLLW6R',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSK6IDrm6Z6HgYpZ4V7YD5',
            } as StripePlan,
        ],
    },
    'twelve-degree-launch': {
        name: 'Twelve Degree Launch',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OrNDEIDrm6Z6HgYPWjt7AxN',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrSKOIDrm6Z6HgYOFCJB4cV',
            } as StripePlan,
        ],
    },
    '5-star': {
        name: '5 Star',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Os8hlIDrm6Z6HgYGJjxfH1q',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1Os8iAIDrm6Z6HgYOUxMkWsE',
            } as StripePlan,
        ],
    },
    'east-cobb': {
        name: 'East Cobb',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OtFbMIDrm6Z6HgYiczfPVNV',
                price: 4999,
                price_monthly: 4999,
            } as StripePlan,
        ],
        features: {
            headsetFinancing: {
                upfrontPayment: 0,
                numberOfMonths: 12,
                monthlyPayment: 2500,
            },
        },
    },
    'east-cobb-bullets': {
        name: 'East Cobb Bullets',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PQe3XIDrm6Z6HgY6WZWd89P',
                price: 1900,
                price_monthly: 1900,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PQe3hIDrm6Z6HgYC7Bm1aHQ',
                price: 22800,
                price_monthly: 1900,
            } as StripePlan,
        ],
        features: {
            headsetFinancing: {
                upfrontPayment: 0,
                numberOfMonths: 12,
                monthlyPayment: 2500,
            },
        },
    },
    'exposure': {
        name: 'eXposure',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXVYIDrm6Z6HgYqteI7lBf',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXViIDrm6Z6HgY13f3t2d7',
            } as StripePlan,
        ],
    },
    'cba': {
        name: 'CBA',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXVuIDrm6Z6HgYvgHtjUXa',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXW3IDrm6Z6HgYyvNsOvi5',
            } as StripePlan,
        ],
    },
    'hardcore-elite': {
        name: 'Hardcore Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXWEIDrm6Z6HgYrHbvlESD',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXWPIDrm6Z6HgYd50kVPlu',
            } as StripePlan,
        ],
    },
    'lonestar': {
        name: 'Lonestar - North',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXXCIDrm6Z6HgYU78BrYex',
            } as StripePlan,
        ],
    },
    'lonestar-central': {
        name: 'Lonestar - Central',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PNkUxIDrm6Z6HgYpRwsY21z',
            } as StripePlan,
        ],
    },
    'lonestar-south': {
        name: 'Lonestar - South',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PNkVmIDrm6Z6HgY1rMPL2mD',
            } as StripePlan,
        ],
    },
    '3-step': {
        name: '3 Step',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXXtIDrm6Z6HgYKfbqsmiL',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXY9IDrm6Z6HgYZgWLRQIC',
            } as StripePlan,
        ],
    },
    'knights-knation': {
        name: 'Knights Knation',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXYKIDrm6Z6HgYxjWya9EP',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXYUIDrm6Z6HgYNYGoHBIl',
            } as StripePlan,
        ],
    },
    'knights-knation-alabama': {
        name: 'Knights Knation Alabama',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PF3FTIDrm6Z6HgYCkP8nFVi',
            } as StripePlan,
        ],
    },
    'grb-rays': {
        name: 'GRB Rays',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXYhIDrm6Z6HgYN9oQ62HO',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXYrIDrm6Z6HgYlOSdxKCv',
            } as StripePlan,
        ],
    },
    'gbg': {
        name: 'GBG',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXZ0IDrm6Z6HgY8OxFhODY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXZ9IDrm6Z6HgYrykso14C',
            } as StripePlan,
        ],
    },
    'ebc': {
        name: 'EBC',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXZJIDrm6Z6HgY6KdgNkr8',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXZRIDrm6Z6HgY6YOoFr6N',
            } as StripePlan,
        ],
    },
    'indiana-bulls': {
        name: 'Indiana Bulls',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXrwIDrm6Z6HgYi4H0LmZZ',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXs7IDrm6Z6HgYB61E3svM',
            } as StripePlan,
        ],
    },
    'select1': {
        name: 'WIN Player Development Program',
        alias: 'All Star Sports Academy',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXsOIDrm6Z6HgYXjiPVLdP',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXsXIDrm6Z6HgYjz1W72aR',
            } as StripePlan,
        ],
    },
    'the-show-new-england': {
        name: 'The Show New England',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXXZIDrm6Z6HgYodpK6JJ7',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXXkIDrm6Z6HgYsETj23DP',
            } as StripePlan,
        ],
    },
    'noreasters': {
        name: 'Nor\'Easters',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPQkIDrm6Z6HgYNqTik79S',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPQvIDrm6Z6HgYXqB5mWoI',
            } as StripePlan,
        ],
    },
    'prospects-athletics': {
        name: 'Prospects Athletics',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPR4IDrm6Z6HgYIe3YF1NY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPRLIDrm6Z6HgYPx6JdkvJ',
            } as StripePlan,
        ],
    },
    'bay-sox': {
        name: 'Bay Sox',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPRXIDrm6Z6HgYNZGlGATU',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPRhIDrm6Z6HgYw45yMWgc',
            } as StripePlan,
        ],
    },
    'seacoast': {
        name: 'Seacoast',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPRrIDrm6Z6HgY7pFHjzQQ',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPS4IDrm6Z6HgYRu9TCieQ',
            } as StripePlan,
        ],
    },
    'northeast-hurricanes': {
        name: 'Northeast Hurricanes',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPSQIDrm6Z6HgY2sQ69yXc',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPSaIDrm6Z6HgYIgNJENr6',
            } as StripePlan,
        ],
    },
    'midland': {
        name: 'Midland',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPSlIDrm6Z6HgY56PgRetW',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPSvIDrm6Z6HgYOZTj8bKi',
            } as StripePlan,
        ],
    },
    'grb-stiks': {
        name: 'GRB STiKS',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HiTIDrm6Z6HgYC64vIgBc',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HidIDrm6Z6HgYnNJIJJ56',
            } as StripePlan,
        ],
    },
    'grb-illinois': {
        name: 'GRB Illinois',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HilIDrm6Z6HgYpvQ7uFbz',
            } as StripePlan,
        ],
    },
    'grb-northstar': {
        name: 'GRB Northstar',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HjAIDrm6Z6HgYPLYBv8JH',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HjIIDrm6Z6HgYQAafKWJ9',
            } as StripePlan,
        ],
    },
    'dakota-select': {
        name: 'Dakota Select',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HjWIDrm6Z6HgYBWxCqOXb',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HjnIDrm6Z6HgYrqQiHqva',
            } as StripePlan,
        ],
    },
    'clubhouse-ct': {
        name: 'Clubhouse CT',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3n7NIDrm6Z6HgYinlxEbgF',
                price: 9900,
                price_monthly: 9900,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3n7ZIDrm6Z6HgYTOpAzsBF',
                price: 99900,
                price_monthly: 8325,
            } as StripePlan,
        ],
    },
    'wildcats-baseball': {
        name: 'Wildcats Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3n7sIDrm6Z6HgY55q3rmq7',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3n84IDrm6Z6HgYP3aOE87p',
            } as StripePlan,
        ],
    },
    'original-florida-pokers': {
        name: 'Original Florida Pokers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3n8RIDrm6Z6HgYTYqXesUh',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3n8eIDrm6Z6HgYZiYqaXQK',
            } as StripePlan,
        ],
    },
    'midland-marlins': {
        name: 'Midland Marlins',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3n8zIDrm6Z6HgYa72hdWuR',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3n99IDrm6Z6HgYapVU23nk',
            } as StripePlan,
        ],
    },
    'cooperstown-cobras': {
        name: 'Cooperstown Cobras',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3n9QIDrm6Z6HgYsrPpyAb2',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3n9aIDrm6Z6HgYmjr1QWQu',
            } as StripePlan,
        ],
    },
    'canes': {
        name: 'Canes',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3pPmIDrm6Z6HgYHbAK0Qtv',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3pPyIDrm6Z6HgYiqH87Lht',
            } as StripePlan,
        ],
    },
    'd-bat': {
        name: 'D-Bat',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3pQ6IDrm6Z6HgYQ9jQT5mT',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3pQGIDrm6Z6HgYeuoL0Q9g',
            } as StripePlan,
        ],
    },
    'select2': {
        name: 'WIN Player Development Program',
        alias: 'Tim Dulin',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P5afCIDrm6Z6HgYc0e3nwhh',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P5afMIDrm6Z6HgYTOrvfmvA',
            } as StripePlan,
        ],
    },
    'select3': {
        name: 'WIN Player Development Program',
        alias: 'Baseball USA',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P6bAPIDrm6Z6HgY6E2IlB7S',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P6bAZIDrm6Z6HgYjNO302eh',
            } as StripePlan,
        ],
    },
    'sc-panthers': {
        name: 'SC Panthers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P733eIDrm6Z6HgYH82NCMfY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P733pIDrm6Z6HgYnym0N8hc',
            } as StripePlan,
        ],
    },
    'grb-north': {
        name: 'GRB North',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8NtLIDrm6Z6HgYKQtELaww',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8NtWIDrm6Z6HgYCXU45aju',
            } as StripePlan,
        ],
    },
    'tbt': {
        name: 'TBT',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8W3vIDrm6Z6HgYeo52Srv1',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8W45IDrm6Z6HgYiltHnHDq',
            } as StripePlan,
        ],
    },
    'texas-glory': {
        name: 'Texas Glory',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8W4GIDrm6Z6HgYpyffU9sM',
            } as StripePlan,
        ],
    },
    'select4': {
        name: 'WIN Player Development Program',
        alias: 'Sean Danielson',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8W4cIDrm6Z6HgYgvRbPcO4',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8W4mIDrm6Z6HgYgSMKEOzE',
            } as StripePlan,
        ],
    },
    'dingers-batting-cages': {
        name: 'Dingers Batting Cages',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8W4wIDrm6Z6HgYD0SfWLag',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8W58IDrm6Z6HgYyUDhokmQ',
            } as StripePlan,
        ],
    },
    'new-level-baseball': {
        name: 'New Level Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8q3eIDrm6Z6HgYNLTzTDv5',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8q3oIDrm6Z6HgYHAgqMjE9',
            } as StripePlan,
        ],
    },
    'waco-storm': {
        name: 'Waco Storm',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8q3yIDrm6Z6HgYcgStKepa',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8q48IDrm6Z6HgYwkq9m0Sw',
            } as StripePlan,
        ],
    },
    'oklahoma-fuel': {
        name: 'Oklahoma Fuel',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P8q4HIDrm6Z6HgYHOoetnIY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P8q4QIDrm6Z6HgYluBkWDiw',
            } as StripePlan,
        ],
    },
    'ninth-inning-royals': {
        name: 'Ninth Inning Royals',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3cJIDrm6Z6HgYZGWHGV9W',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3cUIDrm6Z6HgYgPCvWgJ0',
            },
        ],
    },
    'vipers-sting': {
        name: 'Vipers-Sting',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PBPR1IDrm6Z6HgY7HgqxaDD',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PBPRDIDrm6Z6HgYbSiGmKYb',
            },
        ],
    },
    'texas-generals': {
        name: 'Texas Generals',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3jWIDrm6Z6HgYLQA5lkHh',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3jfIDrm6Z6HgYG6Sg9OmK',
            },
        ],
    },
    'citius-baseball': {
        name: 'Citius Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3jwIDrm6Z6HgYDqmNwBwu',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3k6IDrm6Z6HgYMdKHd5yr',
            },
        ],
    },
    'texoma-baseball-academy': {
        name: 'Texoma Baseball Academy',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3kXIDrm6Z6HgYHKExi749',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3kjIDrm6Z6HgY49unkmWL',
            },
        ],
    },
    'stars-showcase-baseball': {
        name: 'Stars Showcase Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3pCIDrm6Z6HgYhc8C9XKl',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3pMIDrm6Z6HgYvdQt4F6Y',
            },
        ],
    },
    'florida-burn': {
        name: 'Florida Burn',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3plIDrm6Z6HgYB1zdL7Dy',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3pwIDrm6Z6HgY5Gs82e7Z',
            },
        ],
    },
    'texas-cannons': {
        name: 'Texas Cannons',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3qCIDrm6Z6HgYcc4tdZ2v',
            },
        ],
    },
    'ej-sports': {
        name: 'EJ Sports',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3qcIDrm6Z6HgYx1Y7kOjb',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3r2IDrm6Z6HgYaU6tKbKA',
            },
        ],
    },
    'v8-baseball': {
        name: 'V8 Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3rLIDrm6Z6HgYbFMsCbqR',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3rZIDrm6Z6HgY7pp87GLa',
            },
        ],
    },
    'unleashed-sports-group': {
        name: 'Unleashed Sports Group',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3rpIDrm6Z6HgYCv5d0lKr',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3ryIDrm6Z6HgYPZcvRYt3',
            },
        ],
    },
    'cangelosi-sparks': {
        name: 'Cangelosi Sparks',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3tXIDrm6Z6HgYevWrOXcE',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3tkIDrm6Z6HgYJ3C7X6Lq',
            },
        ],
    },
    'dallas-baseball-club': {
        name: 'Dallas Baseball Club',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3u9IDrm6Z6HgYdy4InSsK',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3uNIDrm6Z6HgYfuwVACaz',
            },
        ],
    },
    'action-baseball': {
        name: 'Action Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3ugIDrm6Z6HgYYAMmWjmw',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PC3upIDrm6Z6HgYKS86RRou',
            },
        ],
    },
    'texas-crew-baseball': {
        name: 'Texas Crew Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqJPIDrm6Z6HgYQtb1wRmt',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqJhIDrm6Z6HgYRZkZroHF',
            },
        ],
    },
    'cavalry-baseball': {
        name: 'Cavalry Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqJzIDrm6Z6HgYn8UMl8RJ',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqK9IDrm6Z6HgYoh6UV4z3',
            },
        ],
    },
    'buzz-lightning-baseball-academy': {
        name: 'Buzz Lightning Baseball Academy',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqKSIDrm6Z6HgYT5mseJu4',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqKdIDrm6Z6HgYcGES4EJt',
            },
        ],
    },
    'dirtbags': {
        name: 'Dirtbags',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqKvIDrm6Z6HgYjytgcV0g',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqL8IDrm6Z6HgYccZtN7Uk',
            },
        ],
        features: {
            headsetFinancing: {
                upfrontPayment: 0,
                numberOfMonths: 12,
                monthlyPayment: 2500,
            },
        },
    },
    'athletes-lab': {
        name: 'Athletes Lab',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqLOIDrm6Z6HgYyFMqbQ8L',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqLXIDrm6Z6HgYMgpDaIzc',
            },
        ],
    },
    'north-texas-longhorns': {
        name: 'North Texas Longhorns',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PCqLmIDrm6Z6HgYSUKRTMns',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PCqLuIDrm6Z6HgYueWtzOWP',
            },
        ],
    },
    'off-speed-athletics': {
        name: 'Off Speed Athletics',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PE9OZIDrm6Z6HgYTauet3sv',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PE9OyIDrm6Z6HgYzbmLL08V',
            },
        ],
    },
    'midland-titans': {
        name: 'Midland Titans',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PE9QJIDrm6Z6HgYbvX9HAcx',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PE9QcIDrm6Z6HgYSWr2aIC9',
            },
        ],
    },
    'pbr': {
        name: 'Prep Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1ODDw3IDrm6Z6HgYzIRCjuCK',
            },
        ],
        coupon: 'PBRdiscount',
    },
    'baseball-academics': {
        name: 'Baseball Academics',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PC3eqIDrm6Z6HgYrdXEsI9T',
            },
        ],
    },
    'rawlings-tigers': {
        name: 'Rawlings Tigers',
        message: 'Online Hitting Program',
        // coupon: 'RawlingsTigers1',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PQGdRIDrm6Z6HgYiH38eBpX',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PQGddIDrm6Z6HgYozuoxKJ5',
            },
        ],
    },
    'texas-twelve-katy': {
        name: 'Texas Twelve - Katy',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PORmTIDrm6Z6HgYsYhRNTNy',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PORmeIDrm6Z6HgYUN7F3Oe9',
            } as StripePlan,
        ],
    },
    'texas-twelve-woodlands': {
        name: 'Texas Twelve - Woodlands',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PORmsIDrm6Z6HgYH6BFIgun',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PORn4IDrm6Z6HgYtuFOaDHC',
            } as StripePlan,
        ],
    },
    'texas-twelve-south-texas': {
        name: 'Texas Twelve - South Texas',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PORnDIDrm6Z6HgYBY4SPrI9',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PORnNIDrm6Z6HgY0EvVoNeC',
            } as StripePlan,
        ],
    },
    'texas-twelve-san-antonio': {
        name: 'Texas Twelve - San Antonio',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PORneIDrm6Z6HgYV38UMWBl',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PORntIDrm6Z6HgY8rpfiYia',
            } as StripePlan,
        ],
    },
    'texas-twelve-college-station': {
        name: 'Texas Twelve - College Station',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PORo7IDrm6Z6HgYN8ewjDT2',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PORoJIDrm6Z6HgYlWPwGznD',
            } as StripePlan,
        ],
    },
    'texas-twelve-baseball': {
        name: 'Texas Twelve - Baseball',
        message: '30-day Free Access: Offseason Credit',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PUFeYIDrm6Z6HgY0zy88c6m',
                price: 4000,
                price_monthly: 4000,
                trial_days: 30,
                hardware_options: hardware.filter(h => h.category === 'short_bat' && h.price === 6930),
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PUFejIDrm6Z6HgYtcBSAExE',
                trial_days: 30,
                hardware_options: hardware.filter(h => h.category === 'short_bat' && h.price === 6930),
            },
        ],
    },
    'hardcore-elite-baseball': {
        name: 'Hardcore Elite Baseball',
        message: '30-day Free Access: Offseason Credit',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Pkc7gIDrm6Z6HgY5TXusH4b',
                trial_days: 30,
                hardware_options: hardware.filter(h => h.category === 'short_bat' && h.price === 6930),
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1Pkc7oIDrm6Z6HgYrPOgwujR',
                trial_days: 30,
                hardware_options: hardware.filter(h => h.category === 'short_bat' && h.price === 6930),
            },
        ],
    },
    'texas-twelve-bay-area': {
        name: 'Texas Twelve - Bay Area',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PsBNAIDrm6Z6HgYrTtrG3v7',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PsBNMIDrm6Z6HgY1AxS4xeY',
            } as StripePlan,
        ],
    },
    'cooperstown-cobras-youth': {
        name: 'Cooperstown Cobras Youth',
        plans: [
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1Pr4fxIDrm6Z6HgYMJ136ifF',
            } as StripePlan,
        ],
        coupon: 'CCY100OFF',
    },
    'rcs': {
        name: 'RCS',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1PnU4TIDrm6Z6HgYHfKrJtNS',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1PnU4nIDrm6Z6HgYxqBH8GCU',
            } as StripePlan,
        ],
    },
    'pa-shockers': {
        name: 'PA Shockers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Ppu3AIDrm6Z6HgYdIk995bU',
            },
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1Ppu3FIDrm6Z6HgYH7gvrACj',
            },
        ],
        features: {
            headsetFinancing: {
                upfrontPayment: 0,
                numberOfMonths: 12,
                monthlyPayment: 2500,
            },
        },
    },
} as Record<string, Org>

function mapTeams(data: Array<Array<string>>) {
    const mappedTeams: Record<string, any> = {}

    data.forEach(teamData => {
        const teamName = teamData[0]
        const teamSlug = teamName.toLowerCase().replace(/\W+/g, '-')

        mappedTeams[teamSlug] = {
            name: teamName,
            plans: [
                { ...monthlyPlan, stripe_price_id: teamData[1] },
                { ...yearlyPlan, stripe_price_id: teamData[2] },
            ],
        }
    })

    return mappedTeams
}

export default { ...orgs, ...mapTeams(newOrgs) }